export default "__VITE_ASSET__ET_YBu0o__"